import Vue from "vue";
import Vuex from "vuex";
import stdMod from "./modules/students";
import empMod from "./modules/emps";
import busMod from "./modules/buses";
import busMainMod from "./modules/busMain";
import payMod from "./modules/income";
import cityMod from "./modules/cities";
import branchMod from "./modules/branches";
import districtMod from "./modules/districts";
import collagesMod from "./modules/collages";
import outMod from "./modules/outcome";
import classesMod from "./modules/classesyears";
import usersMod from "./modules/users";
import rolesMod from "./modules/roles";
import axios from "axios";
import { gapi } from "./modules/api.js";
const url = gapi + "load";
import VueCookies from "vue-cookies";
// import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);
Vue.use(VueCookies);

export default new Vuex.Store({
  state: {
    students: [],
    studentsView: [],
    studentsInfo: [],
    cities: [],
    branchs: [],
    districts: [],
    colleges: [],
    levels: [],
    buses: [],
    nats: [],
    jobs: [],
    workarea: [],
    traffic: [],
    emps: [],
    accountType: [],
    payType: [],
    boxes: [],
    staticValue: [],
    classesYears: [],
    logged: false,
    user: "",
    token: "",
    name: "",
    role: 0,
    roles: [],
    Crole: [],
    serviec: [
      { id: 1, name: "ذهاب وعودة" },
      { id: 2, name: "ذهاب فقط" },
      { id: 3, name: " عودة فقط" },
    ],
    duration: [
      { id: 1, name: "ترم كامل" },
      { id: 2, name: " نصف ترم" },
    ],
  },
  // plugins: [new VuexPersistence().plugin],
  getters: {
    GET_STATICVALUE: (state) => {
      return state.staticValue;
    },
    GET_LEVELS: (state) => {
      return state.levels;
    },
    GET_PAYTYPE: (state) => {
      return state.payType;
    },
    GET_DISTRICT: (state) => {
      return state.districts;
    },
    GET_ROLES: (state) => {
      return state.Crole;
    },
    GET_SROLES: (state) => {
      return state.roles;
    },
    GET_TOKIN: (state) => {
      return state.token;
    },
    GET_NAME: (state) => {
      return state.name;
    },
    GET_SERVICE: (state) => {
      return state.serviec;
    },
    GET_DURATION: (state) => {
      return state.duration;
    },
  },
  mutations: {
    SET_TOKEN(state, payload) {
      state.token = payload.data.access_token;
      state.user = payload.data.email;
      state.role = payload.data.role;
      state.name = payload.data.name;
      state.logged = true;
      VueCookies.set("Ctoken", state.token);
    },
    SET_STUDENTS(state, data) {
      state.students = data;
    },
    SET_STUDENTSVIEW(state, data) {
      state.studentsView = data;
    },
    SET_CITIES(state, data) {
      state.cities = data;
    },
    SET_BRANCH(state, data) {
      state.branchs = data;
    },
    SET_DISTRICTS(state, data) {
      state.districts = data;
    },
    SET_COLLEGES(state, data) {
      state.colleges = data;
    },
    SET_LEVELS(state, data) {
      state.levels = data;
    },
    SET_BUSES(state, data) {
      state.buses = data;
    },
    SET_NATS(state, data) {
      state.nats = data;
    },
    SET_JOBS(state, data) {
      state.jobs = data;
    },
    SET_WORKAREA(state, data) {
      state.workarea = data;
    },
    SET_TRAFFIC(state, data) {
      state.traffic = data;
    },
    SET_EMPS(state, data) {
      state.emps = data;
    },
    SET_ACCOUNTTYPE(state, data) {
      state.accountType = data;
    },
    SET_PAYTYPE(state, data) {
      state.payType = data;
    },
    SET_BOXES(state, data) {
      state.boxes = data;
    },
    SET_STATICVALUE(state, data) {
      state.staticValue = data;
    },
    SET_ROLES(state, data) {
      state.roles = data;
    },
    SET_ROLE_NOW(state, ID) {
      state.Crole = state.roles.find((t) => t.id == ID);
      VueCookies.set("Croles", state.Crole);
    },
    SET_Cookie(state, payload) {
      state.token = payload;
    },
    SET_RoleAfter(state, payload) {
      state.Crole = payload;
    },
  },
  actions: {
    load({ commit }) {
      axios
        .get(url)
        .then((res) => {
          let cities = res.data.cities;
          let districts = res.data.district;
          let colleges = res.data.college;
          let levels = res.data.level;
          let buses = res.data.buses;
          let nats = res.data.nats;
          let jobs = res.data.jobs;
          let workarea = res.data.workarea;
          let traffic = res.data.traffic;
          let emps = res.data.emps;
          let accountType = res.data.accountType;
          let payType = res.data.payType;
          let boxes = res.data.boxes;
          let students = res.data.students;
          let studentsView = res.data.studentsView;
          let staticValue = res.data.staticValue;
          let roles = res.data.roleAccess;

          commit("SET_CITIES", cities);
          commit("SET_DISTRICTS", districts);
          commit("SET_COLLEGES", colleges);
          commit("SET_LEVELS", levels);
          commit("SET_BUSES", buses);
          commit("SET_NATS", nats);
          commit("SET_JOBS", jobs);
          commit("SET_WORKAREA", workarea);
          commit("SET_TRAFFIC", traffic);
          commit("SET_EMPS", emps);
          commit("SET_ACCOUNTTYPE", accountType);
          commit("SET_PAYTYPE", payType);
          commit("SET_BOXES", boxes);
          commit("SET_STATICVALUE", staticValue);
          commit("SET_STUDENTS", students);
          commit("SET_ROLES", roles);
          commit("stdMod/SET_STUDENTS", students, { root: true });
          commit("stdMod/STUDENTS_VIEW", studentsView, { root: true });
          commit("empMod/SET_DATA", res.data.empData, { root: true });
          commit("busMod/SET_DATA", res.data.buses, { root: true });
          commit("busMainMod/SET_DATA", res.data.busesMain, { root: true });
          commit("cityMod/SET_DATA", res.data.cities, { root: true });
          commit("branchMod/SET_DATA", res.data.branchs, { root: true });
          commit("collagesMod/SET_DATA", res.data.college, { root: true });
          commit("payMod/SET_DATA", res.data.payment, { root: true });
          commit("districtMod/SET_DATA", res.data.district, { root: true });
          commit("classesMod/SET_DATA", res.data.classesyears, { root: true });
          var tk = VueCookies.get("Ctoken");
          commit("SET_Cookie", tk);
        })
        .catch((error) => console.log(error));
    },
    loginAction({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(gapi + "v1" + "/login", {
            email: data.email,
            password: data.password,
          })
          .then((res) => {
            commit("SET_TOKEN", res.data);
            commit("SET_ROLE_NOW", res.data.data.role);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    logoutAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .post(gapi + "v1" + "/logout", {
            Authorization: state.token,
          })
          .then((res) => {
            commit("SET_TOKEN", res);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async setCoockie({ commit }) {
      var tk = VueCookies.get("Ctoken");
      var rl = VueCookies.get("Croles");
      await commit("SET_Cookie", tk);
      await commit("SET_RoleAfter", rl);
    },
  },
  modules: {
    stdMod,
    empMod,
    busMod,
    busMainMod,
    payMod,
    cityMod,
    branchMod,
    districtMod,
    collagesMod,
    outMod,
    classesMod,
    usersMod,
    rolesMod,
  },
});
